import {
  Component, ProvideReactive, Vue, Watch,
} from 'vue-property-decorator';
import styles from './app.module.scss';
import WithRender from './app.html';
// components
import Breadcrumb from '@/components/Breadcrumb/breadcrumb';
import { ThemesEnum } from '@/enums/themes';

@WithRender
@Component({
  components: {
    Breadcrumb,
  },
})
export default class App extends Vue {
  public styles = styles;
  theme = ThemesEnum.LIGHT;

  @ProvideReactive()
  get isDarkTheme(): boolean {
    return this.theme === ThemesEnum.Dark;
  }

  @Watch('$route')
  public updateTheme() {
    const { query } = this.$route;
    const selectedTheme = (query.theme as ThemesEnum) || '';

    if (selectedTheme) {
      this.theme = selectedTheme;

      if (this.isValidTheme(selectedTheme)) {
        document.body.dataset.theme = selectedTheme;
      }
    }

    if (selectedTheme && this.isValidTheme(selectedTheme)) {
      document.body.dataset.theme = selectedTheme;
    }
  }

  isValidTheme(theme: ThemesEnum) {
    return [ThemesEnum.LIGHT, ThemesEnum.Dark].includes(theme);
  }
}
